export const language: any ={
    cancel: "Batal",
    ok: "Ok",
}
